<template>
  <div id="contenedor-configuracion-main">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'ConfiguracionMain',
  data() {
    return {};
  },
  mounted() {
    // console.log('ConfiguracionMain');
  },
};
</script>

<style lang="scss">

</style>
